import {useLayoutStore} from './LayoutStore'

export const useLayoutBasePath = () => useLayoutStore(s => s.layoutPullRequest.basePath)
